import React, { useRef, useState } from 'react'
import '../../assets/css/ConsultationForm.css'
import 'bootstrap/dist/css/bootstrap.css'
import { confirmPageTitle, DetailsOfConsultation, Remarks, consultBirthdate, consultContractStatus, consultEmailAddress, consultGender, consultKanaName, consultKanjiName, consultTelephoneNumber, consultZipcode, faceTofacelabelText } from '../../utils/ConsultationAppText'
import ReCAPTCHA from 'react-google-recaptcha'
import { CDP_PUBLIC_URL, REACT_APP_SITE_KEY } from '../../utils/Constants'
import { useIntl } from 'react-intl'
// import ButtonActiveImage from '../../assets/images/form_btn_06.png'
// import ButtonDisableImage from '../../assets/images/form_btn_05.png'
import { useLocation, createSearchParams, useNavigate } from 'react-router-dom'
import { callSaveAPI } from '../../api/CDPAPI'

const ConsultationServiceConfirmPage = () => {
  const location = useLocation()
  const data = location.state
  const navigate = useNavigate()
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const captchaRef = useRef(null)
  const submitData = JSON.parse(JSON.stringify(data))
  // const cookieBannerCode = (document.cookie.match(/BannerCode=([^];)*)/) || ['', ''])[1]
  const handleSubmit = async (e) => {
      window.scrollTo(0, document.body.scrollHeight)
      setLoading(true)
      e.preventDefault()
      const addValueForFaceToFaceRadioButton = '★インターネットで申込されたＦ２Ｆ　Ｌｅａｄｓです。郵便番号以外、住所情報が不足しているため、アポイント取得時に直接ご確認ください。' + submitData.bannerCode
      const addValueForOnlineRadioButton = '★★★ビデオ面談希望★★★インターネットで申込されたオンライン面談希望のＦ２Ｆ　Ｌｅａｄｓです。郵便番号以外、住所情報が不足しているため、アポイント取得時に直接ご確認ください。' + submitData.bannerCode
      if (submitData.faceToface === 'オンライン形式') {
        submitData.consultRemarks = submitData.consultRemarks + addValueForOnlineRadioButton
      } else {
        submitData.consultRemarks = submitData.consultRemarks + addValueForFaceToFaceRadioButton
      }
      recapture()
      setLoading(false)
  }
  const handleBack = () => {
    navigate(
      data.BannerCode ? { pathname: `${CDP_PUBLIC_URL}/consulting`, search: createSearchParams({ BannerCode: data.bannerCode }).toString() } : { pathname: `${CDP_PUBLIC_URL}/consulting` }
    , { state: { formData: data, isBack: true } })
  }

  const checkError = () => {
    if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
      handleBack()
    }
  }
  const recapture = async (e) => {
    const token = await captchaRef.current.executeAsync()
    await callSaveAPI('consult-submit', { ...submitData, recaptchaToken: token })
        .then(res => {
          if (res.status === 200) {
              captchaRef.current.reset()
              navigate(`${CDP_PUBLIC_URL}/consulting/complete`, { state: {} })
          } else {
            checkError()
          }
        }).catch(() => {
          checkError()
        })
  }
  document.title = confirmPageTitle
  return (
    < div className="inputSection">
      <div className="cardContainer row">
        <div className="col-12" style={{ marginTop: '20px' }}>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className='col-sm-12 col-form-labels' id='labels'>{consultKanjiName}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultLastNameKanji}&nbsp;&nbsp;{data.consultFirstNameKanji}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className='col-sm-12 col-form-labels' id='labels'>{consultKanaName}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultLastNameKana}&nbsp;&nbsp;{data.consultFirstNameKana}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{consultBirthdate}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultBirthYear}年{data.consultBirthMonth}月{data.consultBirthDay}日</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{consultGender}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultGender}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className='col-sm-12 col-form-labels' id='labels'>{consultZipcode}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultZipcode}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className='col-sm-12 col-form-labels' id='labels'>{consultTelephoneNumber}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultTelephone}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className='col-sm-12 col-form-labels' id='labels'>{consultEmailAddress}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultEmail}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{faceTofacelabelText}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.faceToface}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails row">
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{consultContractStatus}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-6 col-6">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultContractStatus}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails  row" style={{ alignItems: 'normal' }}>
            <label htmlFor="inputtext" className="col-sm-12 col-form-labels" id='labels'>{DetailsOfConsultation}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className="col-sm-12 col-12">
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.detailsOfConsultation.join(', ')}</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group-inputdetails  row" style={{ alignItems: 'normal' }}>
            <label htmlFor="inputtext" className='col-sm-12 col-form-labels' id='labels'>{Remarks}</label>
            <div className="col-sm-12">
              <div className="row" id="row1">
                <div className='col-sm-12'>
                  <label htmlFor="inputtext" className="col-sm-12 col-form-labels" style={{ padding: 'unset' }}>{data.consultRemarks}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading
      ? <>
        <div className='spinContainer'>
            <div className='spin'></div>
            <span><h2>{intl.formatMessage({ id: 'LoadingMsg' })}</h2></span>
        </div>
      </>
      : <>
        <div className="btnWrapper">
          <div className="inputSection">
            <div className="cardContainer row">
                <p className="btnDiv"><input type="submit" value="入力内容の修正" name="submit" className="btnGrey" onClick={handleBack} /></p>
            </div>
          </div>
          <div className="inputSection">
            <div className="cardContainer row">
                <p className="btnDiv"><input type="submit" value="申込完了" name="submit" className="btnYellow" onClick={handleSubmit} onDoubleClick={handleBack} /></p>
            </div>
          </div>
        </div>
      </>
      }
      <ReCAPTCHA sitekey={REACT_APP_SITE_KEY} size='invisible' ref={captchaRef} />
    </div >

  )
}
export default ConsultationServiceConfirmPage
